import { Link } from "react-router-dom";
import "./Navbar.css";
function Navbar() {
  return (
    <nav className="navbar">

      <div className="logo">
        Nirvana<span>Sol</span>
      </div>

      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/ecommerce">E-Commerce</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contactUs">Contact Us</Link></li>
      </ul>

    </nav>
  );
}

export default Navbar;